// extracted by mini-css-extract-plugin
export var backdropBlur = "_mi-0";
export var contentCard = "_mi-5";
export var frame = "_mi-2";
export var image = "_mi-4";
export var imagePane = "_mi-3";
export var modal = "_mi-1";